import { format } from 'date-fns';

export const getPlayerRoundById = (player, id) => {
    if (!player || !Array.isArray(player.rounds)) return null;

    const foundRound = player.rounds.find((round) => round.roundNo.toString() === id);

    return foundRound || null;
};

export const getPlayerTeeTimeByRoundId = (player, id) => {
    if (!player || !Array.isArray(player.teeTimes)) return null;

    const teeTime = player.teeTimes.find((p) => p.roundNo.toString() === id);

    return teeTime ? teeTime.teeTime : null;
};

export const renderStartHoleByRoundId = (player, id) => {
    if (!player || !Array.isArray(player.teeTimes)) return null;

    let holesPlayed = 0;
    if (Array.isArray(player.rounds) && player.rounds[id - 1]) {
        holesPlayed = player.rounds[id - 1].holesNoPlayed;
    }

    const teeTime = player.teeTimes.find((p) => p.roundNo.toString() === id);

    if (teeTime && teeTime.isStartingFromTenthHole && holesPlayed === 0) return '*';
    return '';
};

export const getRoundParsById = (roundPars, id) => {
    if (!Array.isArray(roundPars)) return null;

    const foundRound = roundPars.find((round) => round.roundId.toString() === id);

    return foundRound || null;
};

export const getPlayerFormattedTeeTimeByRound = (player, roundId) => {
    const teeTime = getPlayerTeeTimeByRoundId(player, roundId);
    let holesPlayed = 0;
    let roundToPar = '';

    if (player && player.rounds[roundId - 1]) {
        holesPlayed = player.rounds[roundId - 1].holesNoPlayed;
        roundToPar = player.rounds[roundId - 1].roundToPar;
    }

    if (holesPlayed > 0) {
        if (roundToPar === 'Par') {
            return 'E';
        }

        const parsedInt = parseInt(roundToPar, 10);

        if (parsedInt > 0) {
            roundToPar = `+${parsedInt}`;
        }

        return roundToPar;
    }

    return teeTime !== null ? format(teeTime.replace('Z', ''), 'h:mm a') : '-';
};

export const renderQualifiedStatus = (data) => {
    const q = data.qualifiedStatus;
    const res = data.reservedStatusNumber;

    if (q == null || q === 'NQ') return '';

    if (q === 'R' || q === 'RES') {
        return `RES ${res}`;
    }

    return `${q}`;
};

export const renderToPar = (toPar) => {
    if (!toPar) return '-';
    if (toPar === 0 || toPar === 'Par') return 'E';

    return toPar;
};

export const renderRoundToPar = (toPar) => {
    if (!toPar) return '-';
    if (toPar === 0 || toPar === 'Par') return 'E';
    if (toPar > 0) return `+${toPar}`;

    return toPar;
};
